import { useState } from "react";
import { useManualAuthoringStore } from "../../store/manualAuthoringStore";

type ManualTOCProps = {
  onEdit: () => void;
};

export default function ManualTOC({ onEdit }: ManualTOCProps) {
  const manual = useManualAuthoringStore((s) => s.presentManual);
  const selectSection = useManualAuthoringStore((s) => s.selectSection);
  const selectSubSection = useManualAuthoringStore((s) => s.selectSubSection);
  const selectedSectionId = useManualAuthoringStore((s) => s.selectedSectionId);
  const selectedSubSectionId = useManualAuthoringStore((s) => s.selectedSubSectionId);

  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const sections = manual?.sections ?? [];

  const toggle = (sectionId: string) => {
    setExpanded((prev) => ({ ...prev, [sectionId]: !prev[sectionId] }));
  };

  return (
    <div className="manual-toc">
      <div className="d-flex justify-content-center mb-3">
        <button className="btn btn-primary btn-sm px-4" onClick={onEdit}>
          Edit TOC
        </button>
      </div>


      {sections.length === 0 && (
        <div className="text-muted small">No sections yet.</div>
      )}

      {sections.map((section) => (
        <div key={section.id} className="manual-toc__section">
          <div
            className={`manual-toc__row manual-toc__row--section ${
              selectedSectionId === section.id && !selectedSubSectionId ? "active" : ""
            }`}
          >
            {/* caret = expand/collapse */}
            <span
              className="manual-toc__caret"
              onClick={() => toggle(section.id)}
            >
              {expanded[section.id] ? "▾" : "▸"}
            </span>

            {/* label = select section */}
            <span className="manual-toc__label-wrap">
              <span
                className="manual-toc__label"
                onClick={() => selectSection(section.id)}
              >
                {section.title}
              </span>
            </span>
          </div>

          {expanded[section.id] &&
            (section.subSections ?? []).map((sub) => (
              <div
                key={sub.id}
                className={`manual-toc__row manual-toc__row--sub ${
                  selectedSubSectionId === sub.id ? "active" : ""
                }`}
                onClick={() => selectSubSection(section.id, sub.id)}
              >
                <span className="manual-toc__label-wrap">
                  <span className="manual-toc__label">{sub.title}</span>
                </span>
              </div>
            ))}
        </div>
      ))}
    </div>
  );
}
